import script from "./NewProjectsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProjectsView.vue?vue&type=script&setup=true&lang=js"

import "./NewProjectsView.vue?vue&type=style&index=0&id=667f6986&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667f6986"]])

export default __exports__